import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-4xl mx-auto py-8">
            <div className="bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-100 dark:border-gray-800 p-6 sm:p-8 lg:p-12">
                <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-4">Privacy Policy</h1>
                <p className="text-gray-600 dark:text-gray-400 mb-8">Last updated: January 2025</p>

                <div className="prose prose-gray max-w-none">
                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">1. Introduction</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Welcome to RewriteKing. We respect your privacy and are committed to protecting your personal data. 
                            This privacy policy will inform you about how we look after your personal data when you visit our 
                            website or use our services.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">2. Information We Collect</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            We collect the following types of information:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>Text data that you input for rewriting purposes</li>
                            <li>Technical data including IP address, browser type, and device information</li>
                            <li>Usage data about how you interact with our service</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">3. How We Use Your Information</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            We use the information we collect to:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>Provide and improve our rewriting services</li>
                            <li>Process your requests and respond to your inquiries</li>
                            <li>Analyze usage patterns to enhance user experience</li>
                            <li>Ensure security and prevent fraud</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">4. Data Security</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            We implement appropriate technical and organizational measures to protect your personal data. 
                            However, no method of transmission over the internet is 100% secure, and we cannot guarantee 
                            absolute security.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">5. Your Rights</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            You have the right to:
                        </p>
                        <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 space-y-2 mb-4">
                            <li>Access your personal data</li>
                            <li>Rectify inaccurate data</li>
                            <li>Request deletion of your data</li>
                            <li>Object to processing of your data</li>
                            <li>Data portability</li>
                        </ul>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">6. Third-Party Services</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            Our service may use third-party services for functionality. These services have their own 
                            privacy policies, and we are not responsible for their practices.
                        </p>
                    </section>

                    <section className="mb-8">
                        <h2 className="text-2xl font-semibold text-gray-900 dark:text-gray-100 mb-4">7. Contact Us</h2>
                        <p className="text-gray-700 dark:text-gray-300 mb-4">
                            If you have any questions about this privacy policy, please contact us at{' '}
                            <a href="mailto:privacy@rewriteking.com" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300">
                                privacy@rewriteking.com
                            </a>
                        </p>
                    </section>
                </div>

                <div className="mt-12 pt-8 border-t border-gray-200 dark:border-gray-800">
                    <Link to="/" className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 font-medium">
                        ← Back to Home
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;

